import { t } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

interface CategorySummaryProps {
  invoiced: number;
  expenses: number | undefined;
  budget: number;
}

const CategorySummary = (props: CategorySummaryProps) => {
  const item = (title: string, value: number) => (
    <div className="flex items-center space-x-4">
      <span className="text-inkLightest text-xl">{title}</span>
      <span className="text-3xl">{currency.formatByWorkspace(value)}</span>
    </div>
  );

  return (
    <div className="flex justify-end space-x-12 pr-3">
      {item(t`Invoiced`, props.invoiced)}
      {props.expenses !== undefined && item(t`Expenses`, props.expenses)}
      {item(t`Budget`, props.budget)}
    </div>
  );
};

export default observer(CategorySummary);
